import Swal_ from './sweetalert2'
import './Alert.css'

const Swal = Swal_ || window.Swal   

export default (app) => {
    
    if(app.ports.alertSuccess){
        app.ports.alertSuccess.subscribe(message => Swal.fire({                    
            title: message.title,
            html: message.text,
            type: 'success',
            icon: 'success',
            iconHtml: '<i class= "zmdi zmdi-check"></>',
            closeButtonHtml: '<i class= "zmdi zmdi-close"></>',
            showCloseButton: false,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false,
			buttonsStyling: false,
            customClass: {
                popup: 'csf-alert-popup',
                container: 'elm-alert elm-alert-success',
                confirmButton: 'btn btn-primary elm-alert-btn elm-alert-btn-confirm',
                cancelButton: 'btn btn-secondary elm-alert-btn'
            }
        }))
    }
    if(app.ports.alertWarning){
        app.ports.alertWarning.subscribe(message => Swal.fire({                    
            title: message.title,
            text: message.text,
            type: 'warning',
            icon: 'warning',
            showCloseButton: false,
            closeButtonHtml: '<i class= "zmdi zmdi-close"></>',
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false,
			buttonsStyling: false,
            customClass:{
                popup: 'csf-alert-popup',
                container: 'elm-alert elm-alert-warning',
                confirmButton: 'btn btn-primary elm-alert-btn elm-alert-btn-confirm',
                cancelButton: 'btn btn-secondary elm-alert-btn'
            }
      }))
    }
    if(app.ports.alertInfo){
        app.ports.alertInfo.subscribe(message => Swal.fire({                    
            title: message.title,
            text: message.text,
            type: 'info',
            icon: 'info',
            showCloseButton: false,
            closeButtonHtml: '<i class= "zmdi zmdi-close"></>',
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false,
			buttonsStyling: false,
            customClass:{
                popup: 'csf-alert-popup',
                container: 'elm-alert elm-alert-info',
                confirmButton: 'btn btn-primary elm-alert-btn elm-alert-btn-confirm',
                cancelButton: 'btn btn-secondary elm-alert-btn'
            }
      }))
    }
    if(app.ports.alertError){
        app.ports.alertError.subscribe(function(message) {                    
            Swal.fire({ 
                title: message.title,
                text: message.text,
                type: 'error',
                icon: 'error',                    
                showCloseButton: false,
                closeButtonHtml: '<i class= "zmdi zmdi-close"></>',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false,
			    buttonsStyling: false,
                customClass:{
                    popup: 'csf-alert-popup',
                    container: 'elm-alert elm-alert-error',
                    confirmButton: 'btn btn-primary elm-alert-btn elm-alert-btn-confirm',
                    cancelButton: 'btn btn-secondary elm-alert-btn'
                }
            })
        })
    }
    if(app.ports.alertConfirm){
        app.ports.alertConfirm.subscribe(message => 
            Swal.fire({
                title: message.title,
                text: message.text,
                icon: 'question',
                showCancelButton: true,
                showCloseButton: false,
                closeButtonHtml: '<i class= "zmdi zmdi-close"></>',
                confirmButtonText: 'ACEPTAR',
                cancelButtonText: 'CANCELAR',
                allowOutsideClick: false,
    			buttonsStyling: false,
                customClass:{
                    popup: 'csf-alert-popup',
                    container: 'elm-alert elm-alert-confirm',
                    confirmButton: 'btn btn-primary elm-alert-btn elm-alert-btn-confirm',
                    cancelButton: 'btn btn-secondary elm-alert-btn'
                
                },
                reverseButtons: true,
                // dangerMode: true,
            }).then(result => {
                if(app.ports.confirm){
                    app.ports.confirm.send({ id: message.id, isConfirmed: result.value || false })
                }
            })
        )
    }
}


         